import styled from 'styled-components';

export const StyledDateTime = styled.div`
  .date-time-answer {
    font-size: 14px;
    color: var(--base-color);
    font-weight: 600;
    line-height: 24px;
    margin-top: 5px;
    width: 95%;
    word-wrap: break-word;
    white-space: pre-wrap;
  }
`;
